import { render, staticRenderFns } from "./OrderEditModal.vue?vue&type=template&id=49537f04&scoped=true"
import script from "./OrderEditModal.vue?vue&type=script&lang=js"
export * from "./OrderEditModal.vue?vue&type=script&lang=js"
import style0 from "./OrderEditModal.vue?vue&type=style&index=0&id=49537f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49537f04",
  null
  
)

export default component.exports